import { FC } from 'react';

import { ToolbarSkeleton } from '../../shared/toolbar/Toolbar.skeleton';
import { CardSkeleton } from './Card.skeleton';
import { DetailsSkeleton } from './QuoteRealtimeDetails.skeleton';
import { ProductSummarySkeleton } from './QuoteRealtimeFormProductSummary.skeleton';
import { QuoteRealtimeFormSidePanelSkeleton } from './QuoteRealtimeFormSidePanel.skeleton';

export const QuoteRealtimeFormSkeleton: FC = () => (
  <div className="d-flex bg-lvl3 h-100" data-e2e="secondary-market-container">
    <div className="d-flex flex-column flex-grow-2">
      <ToolbarSkeleton count={1} />
      <div className="d-flex m-1">
        <div className="col-xl-6 p-2">
          <CardSkeleton labelSize={12}>
            <ProductSummarySkeleton />
          </CardSkeleton>
        </div>
        <div className="col-xl-6 py-2 ps-0 pe-2">
          <CardSkeleton labelSize={12}>
            <DetailsSkeleton />
          </CardSkeleton>
        </div>
      </div>
    </div>
    <QuoteRealtimeFormSidePanelSkeleton />
  </div>
);
